import { createI18n } from 'vue-i18n';
import en from '@/core/i18n/locales/en.ts';
import fr from '@/core/i18n/locales/fr.ts';
import { Plugin } from 'vue';

export const i18n = createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en,
    fr,
  },
});

export const I18nPlugin = {
  install(app) {
    app.use(i18n);
  },
} as Plugin;
